import PaymentRuleForm from "./PaymentRuleForm";

export default PaymentRuleForm;
